import { Item, Td, Th } from "./helperComponents";
import PolicyContent, { ContentItem } from "./PolicyContent";

const privacyPolicyStructure: ContentItem[] = [
	{
		title: "",
		content: (
			<>
				<p>
					A presente Política contém informações sobre o tratamento de dados pessoais realizado pela MOTIVA. Aqui, você encontrará
					informações sobre a forma como seus dados pessoais são utilizados, e, se desejar mais detalhes sobre seu uso, pode entrar em
					contato com nosso DPO, que responderá as dúvidas não cobertas por esta Política.
				</p>
				<p className="font-semibold">MOTIVA</p>
				<p>Edifício Eldorado Business Tower</p>
				<p>Av. Dra. Ruth Cardoso, 8.501, 5º andar, Pinheiros, Município de São Paulo, Estado de São Paulo</p>
				<p>CNPJ/MF sob nº 02.846.056/0001-97</p>
				<p className="font-semibold">O DPO da MOTIVA é:</p>
				<p>Fabio Aparecido Odoni</p>
				<p>encarregado.dadospessoais@motiva.com.br</p>
				<p>
					Como condição para acesso e uso das funcionalidades exclusivas no https://isentos.motivapagamentos.com.br ,{" "}
					<i>
						Você declara que fez a leitura completa e atenta desta Política, estando plenamente ciente, conferindo, assim, sua livre e
						expressa concordância com os termos aqui estipulados, incluindo a coleta dos Dados aqui mencionados, bem como sua utilização
						para os fins abaixo especificados
					</i>
					. Caso Você não esteja de acordo com as disposições desta Política, Você deverá descontinuar o seu acesso ou uso do
					https://isentos.motivapagamentos.com.br.
				</p>
				<br />
				<p className="font-semibold uppercase">NOTA ESPECIAL PARA CRIANÇAS E ADOLESCENTES COM IDADE INFERIOR A 16 ANOS</p>
				<p className="font-semibold">Por favor, não se registre no https://isentos.motivapagamentos.com.br caso tenha menos de 16 anos.</p>
				<p className="font-semibold uppercase">NOTA ESPECIAL PARA representantes legais</p>
				<p className="font-semibold">
					Apesar de proibirmos o registro de crianças e adolescentes com idade inferior a 16 anos, os pais devem supervisionar as atividades
					online dos seus filhos menores de idade.
				</p>
				<p className="font-semibold">
					As atividades de adolescentes maiores de 16 anos e menores de 18 anos devem ser assistidas pelos pais ou representantes legais.
				</p>
			</>
		)
	},
	{
		title: "O que são dados pessoais?",
		content:
			"Dado pessoal diz respeito a qualquer informação relativa a uma pessoa que possa ser utilizada para identificá-la, tanto individualmente quanto a partir de uma análise que envolva vários tipos de informação."
	},
	{
		title: "Como coletamos Dados?",
		content: (
			<>
				<p>
					Os Dados, incluindo Dados Pessoais, poderão ser coletados quando Você os submete ou quando Você interage com o
					https://isentos.motivapagamentos.com.br e serviços das rodovias CCR RioSP, CCR ViaLagos, CCR AutoBAn, CCR ViaOeste, CCR RodoAnel,
					CCR SPVias, ViaRio, CCR ViaSul, CCR ViaCosteira e CCR MSVia.
				</p>
				<p className="font-semibold uppercase">Base de dados</p>
				<p>
					A base de dados formada por meio da coleta de Dados é de nossa propriedade e está sob nossa responsabilidade, sendo que seu uso,
					acesso e compartilhamento, quando necessários, serão feitos dentro dos limites e propósitos dos negócios descritos nesta Política.
				</p>
			</>
		)
	},
	{
		title: "Quais dados nós utilizamos?",
		content: (
			<div>
				<table>
					<thead className="relative">
						<tr>
							<Th>O que coletamos?</Th>
							<Th>Para que coletamos?</Th>
						</tr>
						<tr>
							<Th colSpan={2}>Dados cadastrais</Th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<Td> Nome </Td>
							<Td rowSpan={10}>
								<ul>
									<Item>Identificar Você.</Item>
									<Item>Cumprir as obrigações decorrentes do uso dos nossos serviços.</Item>
									<Item>
										Ampliar nosso relacionamento, informar Você sobre novidades, funcionalidades, conteúdos, notícias e demais
										eventos que consideramos relevantes para Você.
									</Item>
									<Item>Enriquecer sua experiência conosco e promover nossos produtos e serviços.</Item>
									<Item>Cumprir nossas obrigações legais e regulatórias.</Item>
								</ul>
							</Td>
						</tr>
						<tr>
							<Td>CPF/RG/CNH/Certidão de casamento</Td>
						</tr>
						<tr>
							<Td>Cor/Raça</Td>
						</tr>
						<tr>
							<Td>E-mail</Td>
						</tr>
						<tr>
							<Td>Empresa</Td>
						</tr>
						<tr>
							<Td>Endereço/Cidade/Estado/CEP</Td>
						</tr>
						<tr>
							<Td>Telefone/Ramal</Td>
						</tr>
						<tr>
							<Td>Placa/Marca/Modelo/Renavam</Td>
						</tr>
						<tr>
							<Td>Motivo</Td>
						</tr>
						<tr>
							<Td>Mensagem</Td>
						</tr>
					</tbody>
					<thead className="relative">
						<tr>
							<Th colSpan={2}>Dados de identificação digital</Th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<Td>Endereço IP e Porta Lógica de Origem</Td>
							<Td rowSpan={7}>
								<ul>
									<Item>Identificar Você.</Item>
									<Item>
										Cumprir com obrigações legais de manutenção de registros estabelecidas pelo Marco Civil da Internet - Lei
										12.965/2014.
									</Item>
									<Item>Cumprir nossas obrigações legais e regulatórias.</Item>
								</ul>
							</Td>
						</tr>
						<tr>
							<Td>Dispositivo (versão do sistema operacional) </Td>
						</tr>
						<tr>
							<Td>Geolocalização</Td>
						</tr>
						<tr>
							<Td>Registros de data e horário cada ação que Você realizar</Td>
						</tr>
						<tr>
							<Td>Quais telas Você acessou</Td>
						</tr>
						<tr>
							<Td>ID da sessão</Td>
						</tr>
						<tr>
							<Td>Cookies</Td>
						</tr>
					</tbody>
				</table>
				<br />
				<p className="font-semibold uppercase">dados necessários</p>
				<p>
					Muitos de nossos serviços dependem diretamente de alguns Dados informados na tabela acima, principalmente Dados cadastrais. Caso
					você opte por não fornecer alguns desses Dados, podemos ficar impossibilitados de prestar total ou parcialmente nossos serviços à
					Você.
				</p>
				<p className="font-semibold uppercase">ATUALIZAÇÃO E VERACIDADE DOS DADOS</p>
				<p>
					Você é o único responsável pela precisão, veracidade ou falta dela em relação aos Dados que você fornece ou pela sua
					desatualização. Fique atento pois é de sua responsabilidade garantir a exatidão ou mantê-los atualizados.
				</p>
				<p>
					Da mesma forma, Nós não somos obrigados a processar ou tratar quaisquer dos seus Dados se houver razões para crer que tal
					processamento ou tratamento possa nos imputar qualquer infração de qualquer lei aplicável, ou se você estiver utilizando o
					https://isentos.motivapagamentos.com.brpara quaisquer fins ilegais, ilícitos ou contrários à moralidade.
				</p>
			</div>
		)
	},
	{
		title: "A MOTIVA compartilha meus dados pessoais com terceiros?",
		content: (
			<>
				<p>Nós não compartilhamos seus dados pessoais com terceiros exceto nos casos descritos abaixo:</p>
				<ul className="pl-2">
					<Item>Quando tivermos obtido o seu consentimento para o compartilhamento de seus dados pessoais;</Item>
					<Item>Com empresas afiliadas dentro da MOTIVA;</Item>
					<Item>
						Com prestadores de serviço e parceiros de negócio da MOTIVA, que realizem o tratamento de dados pessoais em nome da MOTIVA;
					</Item>
					<Item>
						Com prestadores de serviço e parceiros de negócio da MOTIVA, no contexto do contrato de concessão, além de outras condutas
						ilícitas com risco de dano elevado, no interesse da MOTIVA e da proteção de terceiros.
					</Item>
					<Item>
						Com a Administração Pública, em cumprimento a obrigações legais e contratuais, inclusive no contexto de contratos de
						concessão, permissão ou autorização;
					</Item>
					<Item>
						Com autoridades policiais conforme requerido pela lei ou quando razoavelmente necessário para proteger os direitos, a
						propriedade e/ou a segurança do Usuário, de terceiros e/ou da MOTIVA; e
					</Item>
					<Item>
						Com autoridades judiciais, administrativas ou governamentais competentes, sempre que houver determinação legal, requerimento,
						requisição ou ordem judicial;{" "}
					</Item>
					<Item>
						Quando necessário às atividades comerciais e aos serviços prestados por Nós por meio do
						https://isentos.motivapagamentos.com.br;
					</Item>
					<Item>De forma automática, em caso de movimentações societárias, como fusão, aquisição e incorporação.</Item>
				</ul>
				<p className="font-semibold uppercase">PARCEIROS COMERCIAIS</p>
				<p>
					Nós possuímos parceiros comerciais que, eventualmente, podem oferecer serviços por meio de funcionalidades ou sites que podem ser
					acessados a partir do https://isentos.motivapagamentos.com.br. Os Dados fornecidos por Você a estes parceiros serão de
					responsabilidade destes, estando assim sujeitos às suas próprias práticas de coleta e uso de dados.
				</p>
				<p>
					Caso empresas terceirizadas realizem o Tratamento em nosso nome de quaisquer Dados Pessoais que coletamos, as mesmas respeitarão
					as condições aqui estipuladas e as normas de segurança da informação, obrigatoriamente.
				</p>
				<p className="font-semibold uppercase">Anonimização de dados</p>
				<p>
					Para as finalidades de pesquisas de inteligência de mercado, divulgação de dados à imprensa e realização de propagandas, os dados
					fornecidos por Você serão compartilhados de forma anonimizada, isto é, de forma que não possibilite a sua identificação.
				</p>
			</>
		)
	},
	{
		title: "Como controladores dos seus dados pessoais temos como responsabilidades: ",
		content: (
			<ul className="pl-2">
				<Item>Registrar as atividades de tratamento;</Item>
				<Item>Adotar medidas de segurança técnicas e administrativas;</Item>
				<Item>Atender aos direitos dos titulares;</Item>
				<Item>Cooperar com a Autoridade Nacional de Proteção de Dados;</Item>
				<Item>Garantir o atendimento aos princípios e bases legais da LGPD.</Item>
			</ul>
		)
	},
	{
		title: "Por quanto tempo a MOTIVA mantém meus dados pessoais?",
		content: (
			<>
				<p>
					Nos mantemos os seus dados pelo período necessário ao cumprimento das finalidades elencadas nesta Política de Privacidade,
					incluindo para o cumprimento de obrigações legais e contratuais no âmbito de contratos de concessão, permissão ou autorização.
					Para informações específicas sobre períodos de retenção de dados, Você pode entrar em contato conosco através do nosso canal de
					comunicação com o encarregado para a proteção de dados pessoais enviando um e-mail para:{" "}
					<a href="mailto:encarregado.dadospessoais@motiva.com.br">encarregado.dadospessoais@motiva.com.br</a>
				</p>
				<p>
					Os Dados Pessoais coletados e os registros de atividades são armazenados em ambiente seguro e controlado em nossos servidores
					locais.
				</p>
				<p>
					Caso Você solicite a exclusão de seus Dados Pessoais, pode ocorrer que os Dados precisem ser mantidos por período superior ao
					pedido de exclusão, nos termos do artigo 16 da Lei Geral de Proteção de Dados Pessoais, para (i) cumprimento de obrigação legal ou
					regulatória, (ii) estudo por órgão de pesquisa, e (iii) transferência a terceiro (respeitados os requisitos de tratamento de dados
					dispostos na mesma Lei). Em todos os casos mediante a anonimização dos Dados Pessoais, desde que possível.
				</p>
				<p>
					Além disso, alguns dados são armazenados por períodos maiores para fins de auditoria, segurança, controle de fraudes, proteção ao
					crédito e preservação de direitos, poderemos permanecer com o histórico de registro de seus Dados por prazo maior nas hipóteses
					que a lei ou norma regulatória assim estabelecer ou para preservação de direitos.
				</p>
				<p>
					Findos o prazo de manutenção e a necessidade legal, os Dados Pessoais serão excluídos com uso de métodos de descarte seguro, ou
					utilizados de forma anonimizada para fins estatísticos.
				</p>
			</>
		)
	},
	{
		title: "Meus dados pessoais são transferidos para outros países?",
		content:
			"Os Dados coletados serão armazenados em nossos servidores localizados no Brasil, bem como em ambiente de uso de recursos ou servidores na nuvem (cloud computing), o que poderá exigir uma transferência e/ou processamento destes Dados fora do Brasil."
	},
	{
		title: "Como posso exercer meus direitos enquanto titular?",
		content: (
			<>
				<p>A Lei Geral de Proteção de Dados lhe garante direitos relacionados aos seus dados pessoais que são:</p>
				<ul className="pl-2">
					<Item>confirmação da existência de tratamento dos seus dados pessoais;</Item>
					<Item>acesso aos seus dados pessoais;</Item>
					<Item>correção de dados pessoais incompletos, inexatos ou desatualizados;</Item>
					<Item>
						anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na
						LGPD, se aplicável;
					</Item>
					<Item>portabilidade dos dados pessoais para outro fornecedor, sujeito à regulamentação da Autoridade Nacional (ANPD);</Item>
					<Item>
						solicitação de apagamento ou anonimização dos dados pessoais tratados com base no seu consentimento, exceto quando a lei
						autorizar a manutenção destes dados por outro fundamento;
					</Item>
					<Item>
						informações sobre as entidades públicas e privadas com as quais Nós tenhamos realizado o uso compartilhado dos seus dados
						pessoais;
					</Item>
					<Item>
						informações sobre a possibilidade de não consentir com o tratamento dos seus dados pessoais e as consequências de tal ação; e
					</Item>
					<Item>revogação de seu consentimento.</Item>
				</ul>
			</>
		)
	},
	{
		title: "A MOTIVA usa cookies?",
		content: (
			<>
				<p>
					A MOTIVA pode utilizar essa tecnologia em seu site, coletando informações automaticamente, como dados de navegação e IP do
					dispositivo. Essas informações serão utilizadas para melhorar sua experiência e para que possamos avaliar o bom funcionamento das
					funcionalidades do portal. Cabe a Você configurar o seu navegador de Internet caso deseje bloqueá-los. Nesta hipótese, algumas
					funcionalidades que oferecemos poderão ser limitadas. Todas as tecnologias utilizadas respeitarão sempre a legislação vigente e os
					termos desta Política.
				</p>
				<p className="italic">Nós não utilizamos nenhum tipo de decisão unicamente automatizada que impacte Você.</p>
			</>
		)
	},
	{
		title: "Informações sobre nossa comunicação digital",
		content: (
			<>
				<p>
					Você reconhece que toda comunicação realizada por e-mail (aos endereços informados no seu cadastro), SMS, aplicativos de
					comunicação instantânea ou qualquer outra forma digital, também são válidas, eficazes e suficiente para a divulgação de qualquer
					assunto que se refira aos serviços que prestamos, aos seus Dados, bem como às condições de sua prestação ou a qualquer outro
					assunto nele abordado, sendo exceção apenas o que essa Política prever como tal.
				</p>
				<p>
					Para otimizar e melhorar nossa comunicação, quando enviamos um e-mail para Você podemos receber uma notificação quando eles são
					abertos, desde que esta possibilidade esteja disponível. É importante você ficar atento, pois os e-mails são enviados somente pelo
					domínio: @motiva.com.br.
				</p>
				<p>
					Em caso de qualquer dúvida com relação às disposições constantes desta Política de Privacidade e Tratamento de Dados, você poderá
					entrar em contato por meio do Canal de Comunicação <strong>E-mail</strong>:{" "}
					<a href="mailto:encarregado.dadospessoais@motiva.com.br">encarregado.dadospessoais@motiva.com.br</a>
				</p>
			</>
		)
	},
	{
		title: "Algumas informações sobre essa política",
		content: (
			<>
				<strong>ALTERAÇÃO DO TEOR E ATUALIZAÇÃO.</strong>
				<p>
					A fim de melhorar seus serviços, a MOTIVA pode atualizar esta Política, conforme a finalidade ou necessidade, tal qual para
					adequação e conformidade legal de disposição de lei ou norma que tenha força jurídica equivalente, cabendo a Você verificá-la
					sempre que efetuar o acesso ao https://isentos.motivapagamentos.com.br ou utilizar nossos serviços.
				</p>
				<p>
					Ocorrendo atualizações neste documento e que demandem nova coleta de consentimento, Você será notificado por meio dos canais de
					contatos que Você informar.
				</p>
			</>
		)
	},
	{
		title: "",
		content: (
			<>
				<br />
				<br />
				<p>Esta política de privacidade é efetiva a partir de outubro de 2025.</p>
			</>
		)
	}
];

export default function PrivacyPolicy(): JSX.Element {
	return <PolicyContent content={privacyPolicyStructure} />;
}
